/* ==========================================================================
   Vildblad 2.9 – Från samma märke (upsell)
   Kunden väljer en produkt från samma märke och lägger den i varukorgen
   tillsammans med produkten på sidan. Rabatten sätts i kassan av de
   automatiska rabatterna "Upsell <märke> <nivå> %". Här räknas bara ut vad
   kunden sparar, med samma regler som kassan:
   - samma nivå på båda: rabatten hamnar på den billigaste av de två
   - olika nivåer: den rabatt som ger mest gäller (de kombineras inte)
   ========================================================================== */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const V = () => window.Vildblad || {};

  const money = (cents) => {
    const n = Number(cents) / 100;
    const whole = Math.abs(n % 1) < 0.005;
    return n.toLocaleString('sv-SE', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }) + ' kr';
  };

  const savings = (mainCents, mainTier, addCents, addTier) => {
    if (mainTier > 0 && addTier > 0 && mainTier === addTier) {
      return Math.round(Math.min(mainCents, addCents) * mainTier / 100);
    }
    const a = mainTier > 0 ? Math.round(mainCents * mainTier / 100) : 0;
    const b = addTier > 0 ? Math.round(addCents * addTier / 100) : 0;
    return Math.max(a, b);
  };

  // Huvudproduktens valda variant läses från produktformuläret på sidan
  const mainForm = () => $$('form[action*="/cart/add"]').find((f) => !f.closest('[data-brand-upsell]') && f.querySelector('[name="id"]'));

  const mainState = (root) => {
    let prices = {};
    try { prices = JSON.parse($('[data-bu-variants]', root)?.textContent || '{}'); } catch (e) { prices = {}; }
    const form = mainForm();
    const id = String(form?.querySelector('[name="id"]')?.value || root.dataset.mainId);
    const cents = Number(prices[id] ?? root.dataset.mainCents);
    return { id: Number(id), cents, tier: Number(root.dataset.mainTier || 0) };
  };

  const update = (root) => {
    const main = mainState(root);
    $$('[data-bu-item]', root).forEach((it) => {
      const add = Number($('[data-complete-price]', it)?.dataset.cents || 0);
      const save = savings(main.cents, main.tier, add, Number(it.dataset.tier || 0));
      const el = $('[data-bu-save]', it);
      if (!el) return;
      el.hidden = save <= 0;
      el.textContent = save > 0 ? `Spara ${money(save)} när du köper båda` : '';
      it.dataset.save = String(save);
    });
    const chosen = $$('[data-bu-item]', root).find((it) => $('[data-bu-choice]', it)?.checked);
    const out = $('[data-bu-sum]', root);
    const btn = $('[data-bu-add]', root);
    if (!chosen) {
      if (out) out.textContent = 'Välj en produkt';
      if (btn) btn.disabled = true;
      return;
    }
    const add = Number($('[data-complete-price]', chosen)?.dataset.cents || 0);
    const save = Number(chosen.dataset.save || 0);
    const total = main.cents + add;
    if (out) {
      out.replaceChildren();
      const label = document.createElement('span');
      label.textContent = 'Båda tillsammans';
      const strong = document.createElement('strong');
      strong.textContent = money(total - save);
      out.append(label, ' ', strong);
      if (save > 0) {
        const s = document.createElement('s');
        s.className = 'bu__was';
        s.textContent = money(total);
        out.append(' ', s);
      }
    }
    if (btn) btn.disabled = false;
  };

  const addBoth = async (root, btn) => {
    const chosen = $$('[data-bu-item]', root).find((it) => $('[data-bu-choice]', it)?.checked);
    const addId = Number($('[data-quick-add]', chosen)?.dataset.quickAdd || 0);
    if (!addId) return;
    const main = mainState(root);
    let inCart = false;
    try {
      const cart = await fetch((V().routes?.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      inCart = (cart.items || []).some((i) => i.variant_id === main.id);
    } catch (e) { inCart = false; }
    const items = inCart ? [{ id: addId, quantity: 1 }] : [{ id: main.id, quantity: 1 }, { id: addId, quantity: 1 }];
    const c = V().Cart;
    if (c && c.add) {
      c.add(items, { button: btn }).catch(() => {});
    } else {
      fetch((V().routes?.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) })
        .then(() => { window.location.href = V().routes?.cart || '/cart'; });
    }
  };

  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    update(root);
    // Val av produkt eller färg i blocket (vänta in vb25.js som byter pris vid färgval)
    root.addEventListener('change', () => setTimeout(() => update(root), 0));
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bu-add]');
      if (btn) { addBoth(root, btn); return; }
      // Hela raden väljer produkten, utom länkar och färgval
      const item = e.target.closest('[data-bu-item]');
      if (!item || e.target.closest('a, select, label, input')) return;
      const radio = $('[data-bu-choice]', item);
      if (radio && !radio.checked) { radio.checked = true; update(root); }
    });
    // Byte av variant på huvudprodukten
    const form = mainForm();
    if (form) {
      form.addEventListener('change', () => setTimeout(() => update(root), 0));
      const idInput = form.querySelector('[name="id"]');
      if (idInput && 'MutationObserver' in window) {
        new MutationObserver(() => update(root)).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }
  };

  $$('[data-brand-upsell]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => $$('[data-brand-upsell]', e.target).forEach(init));
})();
